import React from "react";
import {
  Building2,
  GraduationCap,
  Factory,
  HandHeart,
  DollarSign,
  Laptop,
  ExternalLink,
} from "lucide-react";

import { parceiros } from "../data/mockData";

const PartnersSection = () => {
  const categoryIcons = {
    Acadêmico: GraduationCap,
    Industrial: Factory,
    Empreendedorismo: Building2,
    Governo: HandHeart,
    Financiamento: DollarSign,
    Tecnologia: Laptop,
  };

  const categoryColors = {
    Acadêmico: "bg-blue-100 text-blue-800",
    Industrial: "bg-orange-100 text-orange-800",
    Empreendedorismo: "bg-purple-100 text-purple-800",
    Governo: "bg-red-100 text-red-800",
    Financiamento: "bg-green-100 text-green-800",
    Tecnologia: "bg-indigo-100 text-indigo-800",
  };

  return (
    <section id="partners" className="py-20 bg-white">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-6">
            Nossos Parceiros
          </h2>

          <p className="body-large max-w-3xl mx-auto text-gray-700 mb-8">
            Trabalhamos com organizações líderes para amplificar nosso impacto
            na transformação sustentável da Amazônia.
          </p>

          {/* Call to Partnership */}
          <div className="bg-gradient-to-r from-accent-wash to-transparent p-6 rounded-2xl inline-block">
            <p className="body-medium text-accent-text font-semibold">
              "Junte-se a nós para transformar a Amazônia"
            </p>
          </div>
        </div>

        {/* Partners Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {parceiros.map((parceiro, index) => {
            const IconComponent =
              categoryIcons[parceiro.category] || Building2;

            const categoryClass =
              categoryColors[parceiro.category] ||
              "bg-gray-100 text-gray-700";

            return (
              <div
                key={index}
                className="innovation-card group text-center"
              >
                {/* Partner Logo Placeholder */}
                <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:bg-accent-wash transition-colors">
                  <IconComponent className="w-8 h-8 text-gray-600 group-hover:text-accent-text transition-colors" />
                </div>

                {/* Partner Name */}
                <h3 className="heading-3 text-base mb-2 group-hover:text-accent-text transition-colors">
                  {parceiro.name}
                </h3>

                {/* Category Badge */}
                {parceiro.category && (
                  <span
                    className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${categoryClass}`}
                  >
                    {parceiro.category}
                  </span>
                )}
              </div>
            );
          })}
        </div>

        {/* Partnership Categories Overview */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="text-center">
            <GraduationCap className="w-12 h-12 text-blue-600 mx-auto mb-4" />

            <h3 className="heading-3 mb-2">
              Instituições Acadêmicas
            </h3>

            <p className="body-small text-gray-600">
              Pesquisa e desenvolvimento de soluções inovadoras
            </p>
          </div>

          <div className="text-center">
            <Building2 className="w-12 h-12 text-purple-600 mx-auto mb-4" />

            <h3 className="heading-3 mb-2">
              Organizações Empresariais
            </h3>

            <p className="body-small text-gray-600">
              Implementação e escala de projetos sustentáveis
            </p>
          </div>

          <div className="text-center">
            <HandHeart className="w-12 h-12 text-red-600 mx-auto mb-4" />

            <h3 className="heading-3 mb-2">
              Setor Público
            </h3>

            <p className="body-small text-gray-600">
              Políticas públicas e apoio institucional
            </p>
          </div>
        </div>

        {/* Partnership Call to Action */}
        <div className="bg-gradient-to-r from-accent-primary to-accent-strong p-8 rounded-2xl text-white text-center">
          <Building2 className="w-12 h-12 text-white mx-auto mb-4" />

          <h3 className="heading-3 mb-4 text-white">
            Seja Nosso Parceiro
          </h3>

          <p className="body-medium mb-6 text-white/90 max-w-2xl mx-auto">
            Estamos sempre abertos a novas parcerias que compartilhem nossa
            visão de desenvolvimento sustentável e inovação na Amazônia.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* Quero ser consultor */}
            <a
              href="https://docs.google.com/forms/u/4/d/e/1FAIpQLSdPWCrfX1NAvuEj3tceI2z5_f1piYvIpM7UmK2udX66DpPHFg/viewform?usp=send_form"
              target="_blank"
              rel="noopener noreferrer"
              className="
                inline-flex
                items-center
                justify-center
                gap-2
                bg-white
                text-green-800
                px-6
                py-3
                rounded-full
                font-semibold
                shadow-sm
                hover:bg-gray-100
                hover:shadow-md
                transition-all
              "
            >
              Quero ser consultor

              <ExternalLink className="w-4 h-4" />
            </a>

            {/* Cadastre seu projeto */}
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSf-Qtt1JnM9yhhEvYRMWkbHq-OKgeURMnAiFWkM2vYPCjCMDQ/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="
                inline-flex
                items-center
                justify-center
                gap-2
                border-2
                border-white
                text-white
                px-6
                py-3
                rounded-full
                font-semibold
                hover:bg-white
                hover:text-green-800
                transition-all
              "
            >
              Cadastre seu projeto

              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;